const applicationActions = {
  URL_CHANGE: 'URL_CHANGE',
  URL_STATE_CHANGE: 'URL_STATE_CHANGE',
  HANDLE_OBLIGATIONS: 'HANDLE_OBLIGATIONS',
  CLEAR_OBLIGATIONS: 'CLEAR_OBLIGATIONS',
};

export { applicationActions as default };
